import { PartialTranslation } from '../translations';

export const kk: PartialTranslation = {
  newChat: 'Жаңа сөйлесу',
  search: 'Іздеу',
  user: 'Пайдаланушы',
  settings: 'Баптаулар',
  language: 'Тіл',
  getHelp: 'Көмек алу',
  viewAllPlans: 'Барлық жоспарларды көру',
  learnMore: 'Көбірек білу',
  logOut: 'Шығу',
  chooseLanguage: 'Тілді таңдау',
  chooseYourPreferredLanguage: 'Таңдаулы тіліңізді таңдаңыз',
  searchLanguages: 'Тілдерді іздеу...',
  autoDetect: 'Автоматты анықтау',
  noLanguagesFound: 'Тілдер табылмады',
  askAnything: 'Кез келген нәрсені сұраңыз',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Жеке',
  freePlan: 'Тегін жоспар',
  current: 'Ағымдағы',
  close: 'Жабу',
  archive: 'Мұрағат',
  delete: 'Жою',
  confirmDelete: 'Бұл сөйлесуді жоюға сенімдісіз бе?',
  confirmArchive: 'Бұл сөйлесуді мұрағаттауға сенімдісіз бе?',
  deleteCannotUndo: 'Бұл әрекетті кері қайтару мүмкін емес.',
  archiveCanFind: 'Мұрағаттағаннан кейін мұрағат тізімінен таба аласыз.',
  resources: 'Ресурстар',
  addResource: 'Ресурс қосу',
  deleteResource: 'Ресурсты жою',
  noMatchingResourcesFound: 'Сәйкес ресурстар табылмады',
  noResourcesAvailable: 'Қолжетімді ресурстар жоқ',
  hideResources: 'Ресурстарды жасыру',
  showResources: 'Ресурстарды көрсету',
  typeMessage: 'Хабарлама жазыңыз...',
  thinkingOptions: 'Ойлау нұсқалары',
  deleteFile: 'Файлды жою',
  clearSelection: 'Таңдауды тазалау',
  addAttachment: 'Қосымша қосу',
  sendMessage: 'Хабарлама жіберу',
  deepInsight: 'Терең түсінік · Үстүртөн талдау',
  deepInsightDesc: 'Негізгі тұстарды жылдам түсіну',
  deepExploration: 'Терең зерттеу · Кешенді талдау',
  deepExplorationDesc: 'Көпөлшемді терең зерттеу',
  deepDeconstruction: 'Терең деконструкция · Жүйелі дәлел',
  deepDeconstructionDesc: 'Қабат-қабат прогрессивті талдау',
  contractReview: 'Келісімшартты қарау · Тәуекелді анықтау',
  contractReviewDesc: 'Тармақтарды талдау және сәйкестікті тексеру',
  textPolish: 'Мәтінді жылтырату · Кәсіби өрнек',
  textPolishDesc: 'Тілді оңтайландыру және құрылымды реттеу',
  legalDocuments: 'Заңнамалық құжаттар · Стандартты жоба',
  legalDocumentsDesc: 'Кәсіби заңнамалық құжат жазу',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Кіру',
  register: 'Тіркелу',
  welcomeBack: 'LawHelper-ге қош келдіңіз',
  loginSubtitle: 'Сіздің AI заң зерттеу көмекшіңіз',
  continueWithGoogle: 'Google арқылы жалғастыру',
  continueWithMicrosoft: 'Microsoft арқылы жалғастыру',
  continueWithWeChat: 'WeChat арқылы жалғастыру',
  orContinueWith: 'немесе жалғастыру',
  emailTab: 'Электрондық пошта',
  phoneTab: 'Телефон',
  emailPlaceholder: 'Электрондық поштаңызды енгізіңіз',
  phonePlaceholder: 'Телефон нөмірін енгізіңіз',
  codePlaceholder: '6 таңбалы кодты енгізіңіз',
  sending: 'Жіберілуде...',
  verifying: 'Тексерілуде...',
  verify: 'Растау',
  sendMagicLink: 'Сиқырлы сілтеме жіберу',
  getVerificationCode: 'Кодты алу',
  resendCode: 'Кодты қайта жіберу',
  resendIn: 'Қайта жіберу',
  magicLinkSent: 'Сиқырлы сілтеме электрондық поштаңызға жіберілді',
  magicLinkHint: 'Біз сіздің электрондық поштаңызға қауіпсіз сілтеме жібереміз',
  otpSent: 'Растау коды жіберілді',
  agreeToTerms: 'Жалғастыру арқылы сіз келісесіз',
  privacyPolicy: 'Құпиялылық саясаты',
  termsOfService: 'Қызмет көрсету шарттары',
  and: 'және',
  privacyTitle: 'Сіздің құпиялылығыңыз маңызды',
  privacyIntro: 'Біз сізге ең жақсы тәжірибе беру үшін cookie файлдары мен ұқсас технологияларды қолданамыз.',
  essentialCookies: 'Маңызды cookie файлдары',
  essentialDesc: 'Веб-сайттың жұмыс істеуі үшін қажет',
  analyticsCookies: 'Аналитикалық cookie файлдары',
  analyticsDesc: 'Қызметті жақсартуға көмектеседі',
  marketingCookies: 'Маркетингтік cookie файлдары',
  marketingDesc: 'Жеке контент үшін пайдаланылады',
  acceptAll: 'Барлығын қабылдау',
  essentialOnly: 'Тек маңызды',
  customize: 'Баптау',
  savePreferences: 'Параметрлерді сақтау',
  back: 'Артқа',
  readPrivacyPolicy: 'Біздің құпиялылық саясатын оқыңыз',
  cookiePolicy: 'Cookie саясаты',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI шолу',
  aiDraft: 'AI жоба',
  smartAssistant: 'Үлгі',

  // 知识库搜索
  enableKnowledgeSearch: 'Іздеуді қосу',
  knowledgeSearchDesc: 'AI құжаттарыңызда іздейді',
  clickToDisable: 'Өшіру',
  clickToEnable: 'Қосу',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Ресурстар панелін жабу',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'Жылдам Жауап',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'Бас тарту',
  library: 'Кітапхана',
  filterAll: 'Барлығы',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'Ойланып жатыр...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Қызмет қатесі',
  uploaded: 'Жүктелді',
  settingsGeneral: 'Жалпы',
  settingsNotifications: 'Хабарламалар',
  settingsAppearance: 'Түрі',
  settingsProfile: 'Профиль',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Жарық',
  settingsDark: 'Қараңғы',
  settingsSystem: 'Жүйе',
  about: 'Туралы',
  reviewTitle: 'Құжатты шолу',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Шолу жүруде...',
  reviewComplete: 'Шолу аяқталды',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Заңдық құжат дайындау',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Құрылуда...',
  generatedSuccess: '✅ Құжат құрылды!',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'Тарих',
  drafterNoHistory: 'Тарих жоқ',
  drafterNewChat: 'Жаңа чат',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Құжатты сақтау',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Шығу',
  drafterConfirm: 'Растау',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Дайын',
  workflowCompleted: 'Аяқталды',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Тоқтату',
  restartWorkflow: 'Restart',
  startDrafting: 'Дайындауды бастау',
  interrupt: 'Stop',
  documentSubject: 'Құжат тақырыбы *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Шарт',
  docTypeAgreement: 'Келісім',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Хат',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Ақылды құжат көмекшісі',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Қате',
  unknownError: 'Белгісіз қате',
  file: 'Файл',
  loading: 'Жүктелуде...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI талдау',
};
